import React, { useState, useEffect } from "react";
import { Card } from 'frno-react';
import style from "./index.module.scss";
import FocusLock from "react-focus-lock";
import useStore from "../../../state/state";

const linkToSurvey = "https://surveys.enalyzer.com/survey/linkindex?pid=r6d67kp5";

const PopUpUserSurvey: React.FC = () => {
    const [showPopUp, setShowPopUp] = useState(false);
    const setShowButton = useStore((state) => state.setShowButton);
    const headerText = "Norgespris eller strømstøtte?";
    const bodyText = "Fortell oss hva du trenger slik at du kan ta det rette valget!";

    //delay pop-up showing with 4 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowPopUp(true);
    },3000); 

    return () => clearTimeout(timer);
  }, []);

    return (

    <section>
      {showPopUp && (
        <div className={style.backdrop}>
          <FocusLock>
            <Card
              className={style.card}
              tag="h3"
              title = {headerText}
              titleSize="fs-h3"
              bg="white"
              text={
                <p className="mt-3">
                  {bodyText}<br />
                  <button
                    className={`${style.button} btn-chip chip-fixed`}
                    onClick={() => {
                      window.open(linkToSurvey, "_blank");
                    }}                 
                  >
                    Til undersøkelsen {" "}
                    <i className="fa-regular fa-chevron-right"></i>
                  </button>
                </p>
                }
                closeable={{
                  onClose: () => {
                      setShowPopUp(false);
                      setShowButton(true);
                  },
                }
              }
            />
          </FocusLock>
        </div>
        )}
      </section>
    );
};

const ButtonToSurvey: React.FC = () => {
  const showButton = useStore((state) => state.showButton);
  return (
    <section> 
      {showButton && (
        <div 
        className={`${style.buttonToSurvey} flex-wrap gap-8 mb-8`}>
          <button
            className="btn"
            onClick={() => {
              window.open(linkToSurvey, "_blank");
            }}
            >
            Undersøkelse
            <i className="fa-regular fa-arrow-up-right-from-square"></i>
          </button>
        </div>
      )}
    </section>
  );
};

export { PopUpUserSurvey, ButtonToSurvey };

